// extracted by mini-css-extract-plugin
module.exports = {"root":"ForumIntroBanner_root__4zfGv","iconWrapper":"ForumIntroBanner_iconWrapper___y9yU","copy":"ForumIntroBanner_copy__F9_4M","close":"ForumIntroBanner_close__2oBtv"};